import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailEventsChildProps as Props } from './types';
import type { CompanyEventDetail } from '../../../types/companyDetail';
import { getCompanyEventDetails } from '../../../services/companies';

export const Component: FunctionComponent<Props> = (props) => {
  const [detail, setDetail] = useState<CompanyEventDetail>({
    startDate: '',
    endDate: '',
    eventLocation: '',
    image: null,
    eventTitle: '',
  });

  useEffect(() => {
    let aborted = false;

    const fetchDetail = async () => {
      try {
        const response = await getCompanyEventDetails(props.id);
        if (!aborted) setDetail(response);
      } catch (error) {
        console.log(error);
      }
    };

    fetchDetail();
    return () => {
      aborted = true;
    };
  }, [props.id]);

  return (
    <Presentation
      {...props}
      detail={detail}
    />
  );
};
